import React, { useCallback } from 'react';
import './Guide.less';
import clawImg from '@src/assets/claw/guide/claw.png';
import handImg from '@src/assets/claw/guide/hand.png';
import { botInit } from '@src/services/claw/api';
import useClawStatus, { ClawStatus } from '@src/stores/useClawStatus';
import { ArrowContinueLineIcon, LearningLineIcon, TimeLineIcon, ArcheryLineIcon, Toast } from '@kim/ui';
import { RefreshButton } from '../RefreshButton';

const features = [
  {
    icon: <LearningLineIcon size={24} />,
    title: '专属身份',
    desc: '为助手命名并赋予个性，持续积累与你相关的内容与记忆。',
  },
  {
    icon: <TimeLineIcon size={24} />,
    title: '全天候在线',
    desc: '7×24 小时云端运行，随时响应请求。',
  },
  {
    icon: <ArcheryLineIcon size={24} />,
    title: '自定义技能',
    desc: '为你的助手添加专属技能，掌握特定领域的能力。',
  },
];

export const ClawGuide: React.FC = () => {
  const { setStatus, setInit} = useClawStatus();
  const openClaw = useCallback(async () => {
    botInit().then(res => {
      if (res.status === 'RESOURCE_EXHAUSTED') {
        Toast({
          message: '当前首批体验官已满员。您已进入优先预约名单，下批名单将在近期开启。',
          type: 'warning',
          duration: 3,
        });
        setInit(false);
        setStatus(ClawStatus.NOT_OPEN);
        return;
      }
    });
    setInit(true);
    setStatus(ClawStatus.OPENING);
  }, []);

  return (
    <div className="claw-guide">
      <RefreshButton />
      <div className="claw-guide-hero">
        <div className="claw-guide-hero-lobster">
          <img src={clawImg} alt="" />
        </div>

        <div className="claw-guide-hero-hand">
          <img src={handImg} alt="" />
        </div>

        <div className="claw-guide-hero-content">
          <h1 className="claw-guide-hero-title">认领我的 AI 助手</h1>
          <button
            className="claw-guide-hero-btn"
            onClick={() => openClaw()}
          >
            立即开通
            <ArrowContinueLineIcon size={16} />
          </button>
        </div>
      </div>

      <div className="claw-guide-features">
        {features.map((feat) => (
          <div key={feat.title} className="claw-guide-feature-card">
            <div className="claw-guide-feature-card-icon-wrap">
              {feat.icon}
            </div>
            <div className="claw-guide-feature-card-body">
              <div className="claw-guide-feature-card-title">{feat.title}</div>
              <div className="claw-guide-feature-card-desc">{feat.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClawGuide;
